<template>
  <section class="intro" v-html="page.intro"></section>
</template>

<script>
import { mapState } from "vuex"

export default {
  name: "PageIntro",
  computed: {
    ...mapState(["page"])
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.intro {
  padding: 6rem 3%;
  padding-bottom: 4rem;
  width: 1200px;
  margin: auto;
  max-width: 94%;
  text-align: center;
  font-size: 20px;
}

@media screen and (max-width: 950px) {
  .intro {
    padding: 4rem 3%;
    font-size: 16px;
    padding-bottom: 3rem;
  }
}

@media screen and (max-width: 750px) {
  .intro {
    font-size: 15px;
  }
}
</style>
